import Controller from "../../../../core/js/Controller";

export default class Ads extends Controller {
    constructor() {
        super();
        
        this.pause = 12;
        this.maxPerPause = 2;
        this.closeShowPause = 0;
        this.closePause = 10000;
    }

    afterInit() {
        let time = Math.round(new Date().getTime() / 1000);
        let last_time = parseInt(localStorage.getItem('last_fullscreen_time')) || 0;
        let fs_count = parseInt(localStorage.getItem('fullscreen_count')) || 0;
        let pause = this.pause * 60 * 60;

		if (last_time + pause < time) {
			fs_count = 0;
            localStorage.setItem('fullscreen_count', 0);
            localStorage.setItem('last_fullscreen_time', time.toString());
		}
		
		if (fs_count < this.maxPerPause) {
            this.showFullscreen();
            localStorage.setItem('fullscreen_count', fs_count + 1);
		}
        
        //
//         if (last_time + pause < time && this.isMobile()) {
//             this.showFullscreen();
// 
//             localStorage.setItem('last_fullscreen_time', time.toString());
//         }
    }

    close(e) {
        e.preventDefault();

        this.closeFullscreen();
    }

    isMobile() {
        return window.innerWidth <= 600 && window.innerHeight <= 800;
    }

    showFullscreen() {
        this.closeBtn.style.display = 'none';

        // document.querySelector('html').style.overflow = 'hidden';
        this.app_container.addClass('open');

        setTimeout(function () {
            this.closeBtn.style.display = 'block';
        }.bind(this), this.closeShowPause);

        setTimeout(function() {
            this.closeFullscreen();
        }.bind(this), this.closePause);
    }

    closeFullscreen() {
        // document.querySelector('html').style.overflow = 'auto';
        this.app_container.removeClass('open');
    }
}